export default __webpack_public_path__ + "static/media/kitchen5-afterC-1024w.7e5250a0.webp";